import React from 'react'
import { useSelector } from 'react-redux'
import { formatColorFromApi } from '../../utils/formatData'
import { getColorSettings } from '../../selectors'
import { COLOR_NAME } from '../../constants'

const WrapIcon = ({
    icon: Icon,
    size,
    color = COLOR_NAME.BODY_ICON,
    ...rest
}) => {
    const settings = useSelector(getColorSettings)

    if (!Icon) {
        return null
    }

    return (
        <Icon
            width={size}
            height={size}
            fill={formatColorFromApi(settings[color] || color || '#ffffff')}
            {...rest}
        />
    )
}

export default WrapIcon
